import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-dm-danhmucchungedit',
  templateUrl: './danhmucchungedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./danhmucchungedit.component.scss'],
  providers: [ListService, Repository]
})


export class danhmucchungeditComponent implements OnInit {



  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, Ma: null, Ten: null, SapXep: null, TenTiengNuocNgoai: null
  };
  nhomdtid: string = null;
  hoatdong: string = null;

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('slNhomCTMT', { static: false }) slNhomCTMT: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

  constructor(private _dataService: ListService, public repo: Repository) {


  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {

  }

  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  loadDataInit(nhomdoituongid: string, id: string, donviid: string) {

    //if (nhomdoituongid.toLocaleLowerCase() === Lists_tinhchatnguonkp.id.toLocaleLowerCase())
    //  this.bnguonkinhphi = true;

    //if (nhomdoituongid.toLocaleLowerCase() === Lists_cmmt.id.toLocaleLowerCase())
    //  this.bnhomctmt = true;

    //if (nhomdoituongid.toLocaleUpperCase() == "5E79BF59-78D9-4C54-8EF7-0A242F5CBC24")
    //  this.hoatdong = "Ngừng theo dõi"
    //else
    this.hoatdong = "Hoạt động"

    console.log("testss");
    console.log(nhomdoituongid);
    console.log(donviid);
    console.log(id); 

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      this.currentUser = JSON.parse(authlogin);
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }

    this.nhomdtid = nhomdoituongid;
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);



    //this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/' + id + '/' + donviid)
    //  .subscribe(response => {
    //    this.inputparents = response;
    //  });

    //this.repo.getRequest("api/doituong/getall2/" + Lists_nhomctmt.id + '/null/' + donviid)
    //  .subscribe(response => {
    //    this.inputnhomctmts = response;
    //  });

    this.doituongSelect = {
      Id: null, Ma: null, Ten: null, SapXep: null, TenTiengNuocNgoai: null
      , PhanHeId: null, Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    };
    if (id === null || id === '0') {
      //this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/'+donviid)
      //.subscribe(response => {  
      //    console.log(response);
      //    this.doituongSelect.Ma = response;
      //});
      this.doituongSelect.PhanHeId = nhomdoituongid;
      this.doituongSelect.Created = new Date();
      this.doituongSelect.CreatedBy = this.currentUser.user_name;
      this.doituongSelect.Modified = new Date();
      this.doituongSelect.ModifiedBy = this.currentUser.user_name;

    }
    else {
      console.log("t11");
      this.repo.postRequest("api/danhmucchung/getbyid/", { Id: id, PhanHeId: nhomdoituongid })
        .subscribe(response => {
          console.log(response);
          this.doituongSelect.Id = id;
          this.doituongSelect.Ma = response.Ma;
          this.doituongSelect.Ten = response.Ten;
          this.doituongSelect.TenTiengNuocNgoai = response.TenTiengNuocNgoai;
          this.doituongSelect.PhanHeId = nhomdoituongid;
          this.doituongSelect.Created = response.Created;
          this.doituongSelect.CreatedBy = response.CreatedBy;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;


          this.doituongSelect.SapXep = response.SapXep;
        });
    }


  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    if (this.doituongSelect.Ma == null || this.doituongSelect.Ma == "") {
      swal('Lỗi!', 'Vui lòng nhập mã !.', 'error');
      return;
    }
    if (this.doituongSelect.Ten == null || this.doituongSelect.Ten == "") {
      swal('Lỗi!', 'Vui lòng nhập tên!.', 'error');
      return;
    }
    if (this.doituongSelect.Ma !== null && this.doituongSelect.Ma.length > 100) {
      swal('Lỗi!', 'Mã dài quá. Vui lòng nhập tối đa 100 ký tự!.', 'error');
      return;
    }
    if (this.doituongSelect.Ten !== null && this.doituongSelect.Ten.length > 200) {
      swal('Lỗi!', 'Tên dài quá. Vui lòng nhập tối đa 200 ký tự!.', 'error');
      return;
    }
    if (this.doituongSelect.TenTiengNuocNgoai !== null && this.doituongSelect.TenTiengNuocNgoai.length > 200) {
      swal('Lỗi!', 'Ghi chú dài quá. Vui lòng nhập tối đa 200 ký tự!.', 'error');
      return;
    }
    this.repo.postRequest("api/danhmucchung/addorupdate", this.doituongSelect)
      .subscribe(response => {
        console.log(response);
        if (response == 0 || (response != null && parseInt(response))) {
          //this.doituongSelect.Id = parseInt(response);
          this.save.emit(this.doituongSelect);
        }
        else {
          swal('Lỗi!', response, 'error');
        }
      });
  }







}
